let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4BhtJ")).then(() => parcelRequire('36kNt'));